import { createFileRoute } from '@tanstack/react-router'
import ForgotPassword from "@views/auth/ForgotPassword.tsx";

export const Route = createFileRoute('/_public/forgot-password/')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  return <ForgotPassword />;
}
